import { getBAdminsRoles } from 'granite-admin/common/gateways/business-admin-api';
const fetchBAdminRoles = async (params, signal) => {
  try {
    let data = await getBAdminsRoles({
      ...params,
      ordering: 'name'
    }, signal);
    return data;
  } catch (error) {
    throw error;
  }
};
export { fetchBAdminRoles };